module.exports = __webpack_public_path__ + "static/img/tu2.1b7b850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/tu2.png
// module id = tM5G
// module chunks = 1